import { useState, useEffect } from 'react'

import JsonData from '../../data/data.json'
import { Navigation } from '../navigation'
import Footer from '../footer'
import { Sentryheader } from './sentryheader'
import SentryProducts from './sentryproducts'
import { SentryContact } from './sentrycontact'
import SentryFunctionalities from './SentryFunctionalities'

const SentryOnePage = () => {
  const [landingPageData, setLandingPageData] = useState({})
  useEffect(() => {
    setLandingPageData(JsonData)
    window.scrollTo(0, 0);
  }, [])

  return (
    <div >
      <Navigation></Navigation>
      <Sentryheader></Sentryheader>

      <SentryProducts/>
      <SentryFunctionalities/>

      <SentryContact/>
      <Footer />
    </div>
  )
}

export default SentryOnePage
